export default "__VITE_ASSET__Blr26log__"